module.exports = __webpack_public_path__ + "img/ic_post.812456c7.svg";